import {Component, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormControl, Validators} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatToolbar} from '@angular/material/toolbar';
import {Router, RouterLink} from '@angular/router';

import {ClientService} from '@app/admin/client.service';
import {SetupState, SiteConfigService} from '@app/shared/site-config.service';
import {ReCaptchaV3Service} from 'ng-recaptcha-2';
import {of} from 'rxjs';

import {catchError, mergeMap, reduce} from 'rxjs/operators';

@Component({
    selector: 'frog-create-workspace',
    templateUrl: './create-workspace.component.html',
    styleUrls: ['./create-workspace.component.scss'],
    imports: [
        MatToolbar,
        RouterLink,
        ReactiveFormsModule,
        FormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatButton,
    ],
})
export class CreateWorkspaceComponent implements OnInit {
    public nameControl: UntypedFormControl;
    public error: string;

    constructor(
        private clientService: ClientService,
        private siteConfigService: SiteConfigService,
        private recaptchaService: ReCaptchaV3Service,
        private matSnackBar: MatSnackBar,
        private router: Router,
    ) {
        this.nameControl = new UntypedFormControl('', Validators.required);
        this.error = null;
    }

    ngOnInit(): void {}

    submit() {
        this.recaptchaService
            .execute('createClient')
            .pipe(
                catchError((err) => {
                    this.matSnackBar.open(err.error.detail, 'Ok', {
                        panelClass: 'error-snackbar',
                        verticalPosition: 'top',
                        horizontalPosition: 'center',
                        duration: 0,
                    });

                    return of(null);
                }),
                mergeMap((token) => this.clientService.create(token)),
                mergeMap((client) => {
                    const configData = client.config.data;
                    configData.name = this.nameControl.value;
                    configData.setup = SetupState.Complete;
                    return this.siteConfigService.save(configData);
                }),
                reduce((acc, value) => acc),
            )
            .subscribe((siteConfig) => {
                this.router.navigate(['/s', siteConfig.data.primary_stream]);
            });
    }
}
